import { useEffect, useRef } from "react";

/**
 * 一定時間操作が無ければ onTimeout を呼ぶ簡易版
 * 例: useInactivityLogout(() => logout(), 30 * 60 * 1000)
 */
export default function useInactivityLogout(onTimeout, timeoutMs = 30 * 60 * 1000) {
  const timerRef = useRef(null);

  useEffect(() => {
    if (typeof onTimeout !== "function") return;

    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => onTimeout(), timeoutMs);
    };

    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [onTimeout, timeoutMs]);
}
